import PropTypes from 'prop-types';
import React from 'react';
import classnames from 'classnames';

import './ribbon.scss';

const Ribbon = ({ children, className, packageName }) => {
  const classList = classnames('sm-ribbon', `sm-ribbon--${packageName}`, className);
  return (
    <aside className={classList} data-testid="Ribbon">
      <p className="sm-ribbon__text">{children}</p>
    </aside>
  );
};

Ribbon.propTypes = {
  children: PropTypes.node,
  packageName: PropTypes.string.isRequired,
  className: PropTypes.string,
};

Ribbon.defaultProps = {
  children: 'BEST VALUE',
  className: '',
};

export default Ribbon;
